import { ReactNode } from "react";
import { AlertsCounter } from "shared/components/dataDisplay/AlertsCounter";
import {
  CardSelect,
  CardSelectContent,
  CardSelectTrigger,
  Flex,
  Text,
} from "shared/components/Spor";
import { useTheme } from "styled-components";

export const FilterCardSelect = ({
  label,
  children,
  selectedAmount,
  mt,
}: {
  label: string;
  children: ReactNode;
  selectedAmount?: number | string;
  mt?: number;
}) => {
  const theme = useTheme();
  return (
    <CardSelect>
      <CardSelectTrigger
        variant="core"
        size="sm"
        borderRadius="24px"
        whiteSpace="nowrap"
        maxWidth="100%"
        mt={mt}
      >
        {label}
        {typeof selectedAmount === "number" && selectedAmount > 0 ? (
          <AlertsCounter
            alerts={Number(selectedAmount)}
            semantics="transparent"
          />
        ) : null}
        {typeof selectedAmount === "string" ? (
          <Text>{selectedAmount}</Text>
        ) : null}
      </CardSelectTrigger>
      <CardSelectContent
        background={theme.colorBackgroundMain}
        boxShadow={theme.boxShadow}
        minWidth="10px"
        borderRadius="12px"
      >
        <Flex gap="12px" flexDirection="column" flex="1">
          {children}
        </Flex>
      </CardSelectContent>
    </CardSelect>
  );
};
